<template>
   <div>正在转向注册，请稍候...</div>
</template>

<script>
export default {
  name:"FrameRegisterCallbackPage",
  mounted() {
    try {
      const parts = this.$route.fullPath.split("?");
      if (parts.length < 2) {
        return
      }
      window.parent.postMessage({method: "redirect",url: parts[1]}, "*");
    } catch(e) {
      console.log(e)
    }
  }
}
</script>